import { Typography, Box } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";

const LoadingProgressBar = ({ arr, barHeight }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'linear-gradient(135deg, rgba(248, 248, 248, 0.98) 0%, rgba(241, 241, 241, 0.98) 100%)',
        borderRadius: '12px',
        padding: '24px',
        boxShadow: '0 4px 12px rgba(21, 21, 21, 0.15)',
        minWidth: '320px',
        backdropFilter: 'blur(10px)',
        border: '2px solid rgba(21, 21, 21, 0.1)',
        zIndex: 9999,
        animation: 'fadeIn 0.3s ease-out',
        '@keyframes fadeIn': {
          from: {
            opacity: 0,
            transform: 'translate(-50%, -50%) scale(0.95)',
          },
          to: {
            opacity: 1,
            transform: 'translate(-50%, -50%) scale(1)',
          },
        },
      }}
    >
      <Box
        sx={{
          marginBottom: '16px',
          paddingBottom: '12px',
          borderBottom: '2px solid #ffcb05',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            margin: 0,
            fontSize: '16px',
            fontWeight: 600,
            color: '#151515',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          Cargando datos
        </Typography>
      </Box>
      
      {arr.map((element, index) => (
        <Box
          key={"loading_" + index}
          sx={{
            marginBottom: index < arr.length - 1 ? '16px' : 0,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: '13px',
              color: '#151515',
              fontWeight: 500,
              marginBottom: '8px',
              opacity: 0.8,
            }}
          >
            {element}
          </Typography>
          <LinearProgress
            sx={{
              height: '6px',
              borderRadius: '3px',
              backgroundColor: 'rgba(21, 21, 21, 0.1)',
              '& .MuiLinearProgress-bar': {
                backgroundColor: '#ffcb05',
                borderRadius: '3px',
              },
            }}
          />
        </Box>
      ))}
    </Box>
  );
};

export default LoadingProgressBar;
